"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var getState_1 = require("../../../../../../../../utils/getState");
var LoadingContainer_1 = require("../../../../../../../common/LoadingContainer");
var DebtAdvisoryCommentModalForm_1 = require("./DebtAdvisoryCommentModalForm");
var DebtAdvisoryCommentModalContent = function (props) {
    var DebtAdvisoryCommentAdvisorContent = function () {
        return React.createElement("p", null, "Leave an advisory comment to help determine the best course of action for the user.");
    };
    var DebtAdvisoryCommentUserContent = function () {
        return React.createElement("p", null, "Leave a comment for rradar legal advisors. Once submitted an advisor will reply as soon as possible.");
    };
    return (React.createElement("section", null,
        React.createElement("div", null,
            React.createElement("div", { className: "modal-header flex-row" },
                React.createElement("h3", null, "Make a Comment"),
                React.createElement("div", { className: "flex-row" },
                    React.createElement("div", { className: "isPointer", onClick: function () {
                            props.handleDebtAdvisoryCommentModal();
                        } },
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'times'] }))))),
        React.createElement("div", null,
            (0, getState_1.default)().user.role === 'customer' ? DebtAdvisoryCommentUserContent() : DebtAdvisoryCommentAdvisorContent(),
            React.createElement(LoadingContainer_1.default, { render: function (config) {
                    return React.createElement(DebtAdvisoryCommentModalForm_1.default, __assign({}, config, props));
                } }))));
};
exports.default = DebtAdvisoryCommentModalContent;
